// 判断当前环境
const isDev = import.meta.env.DEV || window.location.hostname === 'localhost';
const isProduction = window.location.hostname === 'gw.930pm.cn';

// 根据环境设置基础 URL
// 开发环境直接返回相对路径，生产环境使用 CDN
const BASE_URL = isDev ? '' : 'https://wcdn.930pm.cn';

export function imagePath(relativePath) {
  // 去掉 '@/assets/images' 并拼接
  const pathWithoutPrefix = relativePath.replace('@/assets/images', '');
  return `${BASE_URL}${pathWithoutPrefix}`;
}